export const DEFAULT_NON_EU_BANNER_REGIONS = [
  "CA", // California
  "QC", // Quebec
];
